import { styled } from '@project44/manifest-ds';

export const Wrap = styled('div', {
  transition: 'max-width 0.2s ease',
  flexShrink: 0,
  maxWidth: 0,
  height: '100%',
  overflow: 'hidden',
  background: 'transparent',
  boxShadow: '$small',
  '> div': {
    borderTopLeftRadius: '0',
    borderBottomLeftRadius: '0',
  },
});
